import { ColorTypes } from '@customTypes/colors';
import { Button, lighten, styled, Theme } from '@mui/material';
import { ButtonVariant } from './Button';

const getHoverBgColor = (
  theme: Theme,
  color: ColorTypes,
  variant: ButtonVariant
): string => {
  if (variant === 'primary') {
    return lighten(theme.palette?.[color].main, 0.4);
  } else if (variant === 'secondary') {
    return lighten(theme.palette?.[color].main, 0.7);
  }
  return 'none';
};

const getButtonBackgroundColor = (
  theme: Theme,
  color: ColorTypes,
  variant: ButtonVariant,
  isDisabled: boolean
): string => {
  if (variant === 'primary') {
    return theme.palette[color].main;
  } else if (variant === 'secondary' && !isDisabled) {
    return lighten(theme.palette[color]?.main, 0.9);
  }
  return 'none';
};

const getButtonTextColor = (
  theme: Theme,
  color: ColorTypes,
  variant: ButtonVariant
): string => {
  if (variant === 'primary') {
    return theme.palette.primary.contrastText;
  }
  return theme.palette[color].main;
};

export const StyledButton = styled(Button)<{
  color: ColorTypes;
  variant: ButtonVariant;
}>(({ theme, color, variant, disabled }) => ({
  '&:disabled': {
    backgroundColor:
      variant === 'primary' && lighten(theme.palette.divider, 0.5),
    color: variant === 'primary' && theme.palette.common.white,
  },
  '&:hover': {
    '@media (hover: hover)': {
      backgroundColor: getHoverBgColor(theme, color, variant),
    },
    '@media (hover: none)': {
      backgroundColor: getButtonBackgroundColor(
        theme,
        color,
        variant,
        !!disabled
      ),
      '&:active': {
        backgroundColor: getHoverBgColor(theme, color, variant),
      },
    },
  },
  background: getButtonBackgroundColor(theme, color, variant, !!disabled),
  color: getButtonTextColor(theme, color, variant),
  borderRadius: theme.spacing(5),
  paddingRight: theme.spacing(16),
  paddingLeft: theme.spacing(16),
  fontWeight: 700,
}));
